const TYPE = '@type';
const NAME_PROPERTY = 'name';
const URL_PROPERTY = 'url';
const SCHEMA_ORG_URL = 'https://schema.org';

const createQuantitativeValue = (unit, value) => ({
  [TYPE]: 'QuantitativeValue',
  unitText: unit,
  value,
});

const createPropertyValue = (type, propertyName, propertyValue) => ({
  [TYPE]: type,
  [propertyName]: propertyValue,
});

const createVehicleEngine = (engineType, enginePower, engineDisplacement) => ({
  [TYPE]: 'EngineSpecification',
  engineType,
  enginePower: createQuantitativeValue(enginePower?.unit, enginePower?.value),
  engineDisplacement: createQuantitativeValue(
    engineDisplacement?.unit,
    engineDisplacement?.value,
  ),
});

export const createSchemaData = (value) => ({
  '@context': SCHEMA_ORG_URL,
  [TYPE]: 'Vehicle',
  [NAME_PROPERTY]: value.name,
  brand: createPropertyValue('Brand', NAME_PROPERTY, value.brand_name),
  model: value.model_name,
  manufacturer: createPropertyValue(
    'Organization',
    NAME_PROPERTY,
    value.brand_name,
  ),
  productionDate: value.year_name,
  description: value.description,
  url: value.url,
  offers: {
    [TYPE]: 'Offer',
    availability: `${SCHEMA_ORG_URL}/${value.availability}`,
    price: value.technical_info?.pricing_info?.price,
    priceCurrency: value.technical_info?.pricing_info?.currency,
    priceSpecification: {
      [TYPE]: 'PriceSpecification',
      minPrice: value.technical_info?.pricing_info?.min_price,
      maxPrice: value.technical_info?.pricing_info?.max_price,
    },
  },
  image: createPropertyValue('ImageObject', URL_PROPERTY, value.image_url),
  fuelType: value.technical_info?.fuel_type,
  vehicleConfiguration: value.technical_info?.configuration,
  vehicleTransmission: value.technical_info?.transmission,
  vehicleEngine: createVehicleEngine(
    value.technical_info?.vehicle_engine?.engine_type,
    value.technical_info?.vehicle_engine?.engine_power,
    value.technical_info?.vehicle_engine?.engine_displacement,
  ),
  width: createQuantitativeValue(
    value.technical_info?.width?.unit,
    value.technical_info?.width?.value,
  ),
  height: createQuantitativeValue(
    value.technical_info?.height?.unit,
    value.technical_info?.height?.value,
  ),
});
